// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__C0DQO","row":"styles_row__3FSf4"};